//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './CalculationTemplatesClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export function getCalculationTemplatesUrl(): string {
  let url_ = getBaseUrl() + "/api/calculation-templates";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getCalculationTemplatesDefaultOptions: Omit<UseQueryOptions<Types.CalculationTemplateDto[], unknown, Types.CalculationTemplateDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.CalculationTemplateDto[], unknown, Types.CalculationTemplateDto[]>, 'queryFn'>> = {
};
export function getGetCalculationTemplatesDefaultOptions() {
  return getCalculationTemplatesDefaultOptions;
};
export function setGetCalculationTemplatesDefaultOptions(options: typeof getCalculationTemplatesDefaultOptions) {
  getCalculationTemplatesDefaultOptions = options;
}

export function getCalculationTemplatesQueryKey(): QueryKey;
export function getCalculationTemplatesQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'CalculationTemplatesClient',
      'getCalculationTemplates',
    ]);
}
export function __getCalculationTemplates(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getCalculationTemplates(
axiosConfig    );
}

/**
 * Gets all templates.
 * @return List with all folders of the user.
 */
export function useGetCalculationTemplatesQuery<TSelectData = Types.CalculationTemplateDto[], TError = unknown>(options?: Omit<UseQueryOptions<Types.CalculationTemplateDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetCalculationTemplatesQuery<TSelectData = Types.CalculationTemplateDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.CalculationTemplateDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.CalculationTemplateDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getCalculationTemplates(context, axiosConfig) : __getCalculationTemplates,
    queryKey: getCalculationTemplatesQueryKey(),
    ...getCalculationTemplatesDefaultOptions as unknown as Omit<UseQueryOptions<Types.CalculationTemplateDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets all templates.
 * @return List with all folders of the user.
 */
export function setGetCalculationTemplatesData(queryClient: QueryClient, updater: (data: Types.CalculationTemplateDto[] | undefined) => Types.CalculationTemplateDto[], ) {
  queryClient.setQueryData(getCalculationTemplatesQueryKey(),
    updater
  );
}

/**
 * Gets all templates.
 * @return List with all folders of the user.
 */
export function setGetCalculationTemplatesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.CalculationTemplateDto[] | undefined) => Types.CalculationTemplateDto[]) {
  queryClient.setQueryData(queryKey, updater);
}